import React from 'react';
import { Drawer, Icon, Button } from '@unite-us/ui';
import { TOP_NAVIGATION_HEIGHT } from '../../../common/constants';
import getNeedIcon from '../utils';
import '../RiskDisplay.scss';
function NeedsList(props) {
  var isSaving = props.isSaving,
    open = props.open,
    clientsNeeds = props.clientsNeeds,
    handleSubmit = props.handleSubmit,
    isSupersetEnabled = props.isSupersetEnabled,
    header = props.header,
    setOpenNeedsList = props.setOpenNeedsList,
    selectedServices = props.selectedServices,
    handleServiceClicked = props.handleServiceClicked,
    handleSelectAll = props.handleSelectAll;
  return /*#__PURE__*/React.createElement(Drawer, {
    open: open,
    onClose: function onClose() {
      return setOpenNeedsList(false);
    },
    topOffset: TOP_NAVIGATION_HEIGHT,
    secondary: true,
    theme: "dark",
    width: "500px"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header-text--drower"
  }, header), clientsNeeds && clientsNeeds.map(function (need) {
    return /*#__PURE__*/React.createElement("div", {
      key: need.name,
      className: "detail-need-card detail-need-card--white-card"
    }, /*#__PURE__*/React.createElement("div", {
      className: "card-title"
    }, /*#__PURE__*/React.createElement("div", {
      className: "card-title__name"
    }, /*#__PURE__*/React.createElement(Icon, {
      icon: getNeedIcon(need.name),
      className: "fill-current text-brand-blue",
      size: 24
    }), /*#__PURE__*/React.createElement("div", {
      className: "title"
    }, need.name.replace('_', ''))), /*#__PURE__*/React.createElement("a", {
      className: "select-btn",
      href: "#",
      onClick: function onClick() {
        return handleSelectAll(need);
      }
    }, "Select All")), /*#__PURE__*/React.createElement("div", {
      className: "checkbox-list"
    }, need.services_subtypes.map(function (service) {
      return /*#__PURE__*/React.createElement("div", {
        key: service.code,
        className: "checkbox-container"
      }, /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        className: "checkbox-icon",
        onChange: function onChange() {
          return handleServiceClicked(service);
        },
        checked: selectedServices.some(function (x) {
          return x.code === service.code;
        })
      }), /*#__PURE__*/React.createElement("span", {
        className: "label"
      }, service.name));
    })));
  }), /*#__PURE__*/React.createElement(Button, {
    className: "resource-btn",
    disabled: isSaving || (selectedServices === null || selectedServices === void 0 ? void 0 : selectedServices.length) === 0,
    fullWidth: true,
    id: "screening-need-selector-submit-button",
    label: "Search for Resources",
    onClick: handleSubmit,
    primary: true
  }));
}
export default NeedsList;
//# sourceMappingURL=NeedsList.js.map